module.exports = __webpack_public_path__ + "img/Mark.01ffcdf4.png";